import React from 'react';
import { Block, BlockBetween, BlockHead, BlockHeadContent, Icon } from '../../../components/Component';
import UAGLogo from "../../../images/logo.png";

const AuthNoData = ({ no_data_message }) => {
 return (
  <div style={{
   height: "40vh",
   display: "flex",
   justifyContent: "center",
   alignItems: "center",
   width: "100%",
   padding: "20px"
  }}>
   <Block size="lg" style={{
    maxWidth: "500px",
    width: "100%",
    animation: "fadeIn 0.3s ease-out"
   }}>
    <BlockBetween className="center">
     <BlockHead>
      <BlockHeadContent>
       {/* Logo Section */}
       <div className="brand-logo text-center" style={{
        marginBottom: "2rem",
        display: "flex",
        justifyContent: "center",
        width: "100%"
       }}>
        <div style={{
         display: "flex",
         flexDirection: "column",
         alignItems: "center",
         width: "100%"
        }}>
         <img
          className="logo-custom-img-main_app_loading w-70"
          src={UAGLogo}
          alt="logo-dark"
          style={{ maxWidth: "100%", height: "250px" }}
         />
        </div>
       </div>

       {/* Compact No Data Message */}
       <div style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "1.5rem",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
        textAlign: "center",
        border: "1px solid rgba(0,0,0,0.03)"
       }}>
        <div style={{
         display: "flex",
         flexDirection: "column",
         alignItems: "center",
         gap: "1rem"
        }}>
         <div style={{
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: "#ebf5ff"
         }}>
          <Icon
           name="alert-circle"
           className="text-primary"
           style={{
            fontSize: "32px",
            color: "#3b82f6"
           }}
          />
         </div>

         <div style={{
          maxWidth: "90%",
          wordBreak: "break-word",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical"
         }}>
          <div
           className="text-soft fw-bold"
           style={{
            fontSize: "1.125rem",
            color: "#2d3748",
            lineHeight: "1.4",
            margin: 0
           }}
          >
           {no_data_message}
          </div>
         </div>
        </div>
       </div>
      </BlockHeadContent>
     </BlockHead>
    </BlockBetween>
   </Block>

   <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
  </div>
 );
};

export default AuthNoData;